import React from 'react';
import * as css from './RoundCheckbox.css';

function RoundCheckbox({checked, onClick}) {
    return (
        <css.checkbox className={checked} onClick={onClick} />
    );
}
export default RoundCheckbox;
